import { useContext } from 'react';
import { ChainlitContext } from 'src/context';

import { useUserManagement } from './userManagement';

export interface UpdateProfileRequest {
  display_name?: string;
}

export interface UpdatePasswordRequest {
  current_password: string;
  new_password: string;
}

export const useProfileManagement = () => {
  const client = useContext(ChainlitContext);
  const { setUserFromAPI } = useUserManagement();

  const updateProfile = async (data: UpdateProfileRequest) => {
    try {
      const response = await client.put('/chat/user/profile', data);
      if (response.ok) {
        // Refresh user data
        await setUserFromAPI();
        return { success: true };
      } else {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || 'Failed to update profile'
        };
      }
    } catch (_error) {
      return { success: false, error: 'Network error occurred' };
    }
  };

  const updatePassword = async (data: UpdatePasswordRequest) => {
    try {
      const response = await client.put('/chat/user/password', data);
      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || 'Failed to update password'
        };
      }
    } catch (_error) {
      return { success: false, error: 'Network error occurred' };
    }
  };

  return {
    updateProfile,
    updatePassword
  };
};
